// Self-contained since the Code → CodePreviewWithTitle rename: the old
// title-only intermediate (previously exported as CodePreviewWithTitle) is
// folded in here so the CodePreviewWithTitle name is free for the public
// head component. Rendering is byte-identical to the old
// Group → title-layer → buttons-layer chain.
export const CodeWithTitleAndButtons = {
  extends: 'Group',
  tag: 'pre',
  margin: '0',
  minWidth: 'F3',
  maxWidth: '50%',
  align: 'stretch',
  '@tabletS': {
    maxWidth: 'none'
  },
  Title: {
    order: null,
    tag: 'h5',
    text: '{{ learn.codeExample.title | polyglot }}',
    fontFamily: 'smbls',
    color: 'caption',
    fontSize: 'Z',
    fontWeight: '500',
    whiteSpace: 'nowrap'
  },
  CodePreview: {
    margin: '0 -Y1',
    round: 'A+X',
    padding: 'A A1 D1',
    '&': {
      minWidth: '100%',
      width: 'auto'
    }
  },
  Buttons: {
    align: 'center space-between',
    margin: '-C+X1 -W 0',
    gap: 'X2',
    transition: 'B opacity',
    '&': {
      minWidth: '100%',
      width: 'auto'
    },
    childExtends: ['WiderButton'],
    childProps: {
      round: 'radiusControl',
      fontSize: 'A',
      transition: 'A',
      transitionProperty: 'background, color, border',
      theme: 'secondary-highlight',
      zIndex: 10
    },
    CopyButton: {
      extends: ['WiderButton', 'CopyButton'],
      margin: '0 auto 0 0',
      icon: 'copy outline',
      value: (el) => {
        const val = el.call('getCodePreviewValue', el.parent.value || '//')
        return val
      }
    },
    Link: {
      href: '/dashboard#{{ title }}',
      ariaLabel: (el) => el.call('polyglot', 'learn.codeExample.openInDashboard'),
      Icon: {
        name: 'url'
      }
    },
    FrameworkSwitcher: {
      padding: 'Z B Z Z2',
      fontSize: 'A',
      fontFamily: 'smbls',
      Icon: {
        name: (el) => {
          const fw = el.getRootState?.()?.framework
          return (fw === 'domql' ? 'symbols' : fw) || 'symbols'
        }
      },
      Icon_arrow: {
        position: 'absolute',
        opacity: 0.5,
        fontSize: 'Z',
        right: 'Z1',
        icon: 'arrowAngleMirroringVertical'
      }
    }
  }
}
